import { atom } from "recoil";

export interface UserSimpleType {
  accessToken?: string;
  nickname?: string;
  email?: string;
  // Google Ads 향상된 전환용 서버 해시 (정규화 후 SHA-256 hex) — 서버가 내려줄 때만 존재
  sha256EmailAddress?: string;
  sha256PhoneNumber?: string;
  userId?: number;
  trackId?: string;
  authenticateType?: string;
  isSubscribing?: boolean;
  hasAlreadyUsed?: boolean;
  paymentPageType?: string;
  pricingModel?: string;
  refundPolicyType?: string;
  isInsider?: boolean;
  isAffiliateEligible?: boolean;
  // 레퍼럴 코드 유형 (affiliate=제휴/discount=단순할인, 레퍼럴로 진입한 경우만)
  referralCodeType?: "affiliate" | "discount";
  promotion?: string;
}

export const userSimpleAtom = atom<UserSimpleType | undefined>({
  key: "userSimple",
  default: undefined,
  // accessToken은 메모리에만 저장 (XSS 공격 방지)
  // refreshToken은 httpOnly 쿠키로 서버에서 관리
});
